define('lib/model/package/PackageDataInflator',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Package data inflator. Adds service/product/attributes data to package/package instance
     *
     * @class PackageDataInflator
     */
    return Marionette.Object.extend({

        attachObjectData: function (data) {
            var _this = this;
            _.each(data.services, function (model) {
                var service = _this.getOption('serviceCollection').get(model.service_id);
                if (service) {
                    model.service = service.toJSON();
                }
            });
            _.each(data.products, function (model) {
                var product = _this.getOption('productCollection').get(model.product_id);
                if (product) {
                    model.product = product.toJSON();
                }
            });
            _.each(data.paid_attributes, function (model) {
                var product = _this.getOption('attributeCollection').get(model.product_id);
                if (product) {
                    model.product = product.toJSON();
                }
            });

            return data;
        },

        attachPackageQtyToInstance: function (data) {
            _.each(data.services, function (model) {
                var pack = _.findWhere(data.package.services, {service_id: model.service_id});
                if (pack) {
                    model.package_qty = pack.qty;
                } else {
                    model.package_qty = 0;
                }
            });
            _.each(data.products, function (model) {
                var pack = _.findWhere(data.package.products, {product_id: model.product_id});
                if (pack) {
                    model.package_qty = pack.qty;
                } else {
                    model.package_qty = 0;
                }
            });
            _.each(data.paid_attributes, function (model) {
                var pack = _.findWhere(data.package.paid_attributes, {product_id: model.product_id});
                if (pack) {
                    model.package_qty = pack.qty;
                } else {
                    model.package_qty = 0;
                }
            });

            return data;
        },

        attachUsedQtyToInstance: function (data, collection) {
            var usedModel = collection.get(data.id);

            if (usedModel) {
                _.each(data.services, function (model) {
                    var used = _.findWhere(usedModel.get('services'), {service_id: model.service_id});
                    if (used) {
                        model.used_qty = used.qty;
                    }
                });
                _.each(data.products, function (model) {
                    var used = _.findWhere(usedModel.get('products'), {product_id: model.product_id});
                    if (used) {
                        model.used_qty = used.qty;
                    }
                });
                _.each(data.paid_attributes, function (model) {
                    var used = _.findWhere(usedModel.get('paid_attributes'), {product_id: model.product_id});
                    if (used) {
                        model.used_qty = used.qty;
                    }
                });
            }
            return data;
        },

        canUseInstanceInInvoice: function (instanceModel, invoiceModel) {
            var products = [];
            var services = [];
            invoiceModel.get('lines').each(function (model) {
                if (model.get('qty') - model.get('package_qty') === 0) {
                    return;
                }
                var bookings = model.get('bookings');
                _.each(bookings, function (booking) {
                    services.push(booking.service_id);
                });
                if (model.get('product_id')) {
                    products.push(model.get('product_id'));
                }
            });

            var canUse = false;
            _.each(instanceModel.get('services'), function (model) {
                if (model.qty > 0 && _.contains(services, model.service_id) || model.used_qty > 0) {
                    canUse = true;
                }
            });
            _.each(instanceModel.get('products'), function (model) {
                if (model.qty > 0 && _.contains(products, model.product_id) || model.used_qty > 0) {
                    canUse = true;
                }
            });
            _.each(instanceModel.get('paid_attributes'), function (model) {
                if (model.qty > 0 && _.contains(products, model.product_id) || model.used_qty > 0) {
                    canUse = true;
                }
            });

            return canUse;
        }

    });

});

